// extracted by mini-css-extract-plugin
export default {"videoInfo":"VideoInfo_videoInfo__FH5u6"};